import { render, staticRenderFns } from "./VerifyPhoneNumber.vue?vue&type=template&id=ca049fe2"
import script from "./VerifyPhoneNumber.vue?vue&type=script&lang=js"
export * from "./VerifyPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports